import App from "./App";
import ReactDOM from "react-dom";
import "./styles/index.css";

ReactDOM.render(<App />, document.querySelector("#root"));
